import { sellerConstants } from '../../../_constants/seller.constants';
import { creditService } from '../../../_services';
import { creditListActions } from './creditlist.actions';

export const revokeCreditAction = {
    addData
};

function addData(data) {
    return dispatch => {
        dispatch(request());
        creditService.revokeCredit(data)
            .then(
                response => {
                    dispatch(creditListActions.getCreditList(data.seller_id));
                    dispatch(success(response));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: sellerConstants.REQUEST_REVOKE_CREDITS} }
    function success(data) { return { type: sellerConstants.RECEIVE_REVOKE_CREDITS, data } }
    function failure(error) { return { type: sellerConstants.REVOKE_CREDITS_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/sellers/sellerCredit/revokeCredit.actions.js